import { useState } from 'react';

import type { Meta, StoryFn } from '@storybook/react';
import type { OverlayStepBarProps } from './OverlayStepBar';

import { OverlayStepBar } from './OverlayStepBar';

const codeString =
  '<OverlayStepBar stepLabels={[string]} activeStep={number} disabledCountPrefix={[numbers]} onStepClick={(step) => void}/>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/OverlayStepBar',
  component: OverlayStepBar,
  argTypes: {
    activeStep: { control: 'number' },
    stepLabels: { control: 'object' },
    disabledCountPrefix: {
      table: {
        disable: true,
      },
    },
    onStepClick: { action: 'stepClicked' },
  },
  parameters: {
    inspectComponent: OverlayStepBar,
    codeString: codeString,
  },
} as Meta<OverlayStepBarProps>;

const Template: StoryFn<OverlayStepBarProps> = (args) => {
  const [activeStep, setActiveStep] = useState(args.activeStep || 1);

  return (
    <OverlayStepBar
      {...args}
      activeStep={activeStep}
      onStepClick={(step) => {
        setActiveStep(step);
        args.onStepClick?.(step);
      }}
    />
  );
};

const defaultArgs: Partial<OverlayStepBarProps> = {
  stepLabels: ['Basic Details', 'Lecturers', 'Period Planning', 'Assessment', 'Miscellaneous', 'Overview'],
};

export const OverlayStepBarExample = Template.bind({});
OverlayStepBarExample.args = {
  ...defaultArgs,
  activeStep: 2,
};

export const OverlayStepBarHidePrifix = Template.bind({});
OverlayStepBarHidePrifix.args = {
  ...defaultArgs,
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  disabledCountPrefix: [1, 6],
  activeStep: 2,
};
